import {combineReducers} from "redux"
import {notificationListSlice} from "../../../scholastic-client-components/src/slices/notificationListSlice"
import {broadcastPreviewSlice} from "../../../scholastic-client-components/src/slices/broadcastPreview/broadcastPreviewSlice"

export const rootReducer = combineReducers({
    notificationList: notificationListSlice.reducer,
    broadcastPreview: broadcastPreviewSlice.reducer,
})

export type RootState = ReturnType<typeof rootReducer>
